import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UzurvRestService } from '@uzurv/rideWss/http';

@Injectable({
  providedIn: 'root'
})
export class ApplicationModeService extends UzurvRestService {
  constructor() {
    super();
  }

  checkApplicationMode(): Observable<boolean> {
    return this.get('applicationModeCheck');
  }
}
